module.exports = "<div></div>\n"